define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"underscore",
	"csi/heading/ActionData",
	"csi/heading/Boolean",
	"csi/xml"
], function(declare, lang, _, ActionData, BooleanRen, xml) {

	return declare(BooleanRen, {

		/**
		 * @override
		 * Keep action enabled even if PartMaterialColor is marked read only after being removed from OnlyForColors
		 */
		_getRenderAction: function(ctx, h) {
			let a = h.m_action;
			a.heading = h;

			if (ctx.isReadOnly() || !xml.nodeHasRight(ctx.getNode(), a.m_right)) {
				return null;
			}

			return lang.mixin(new ActionData(), {
				action: a,
				bTooltip: !a.canBeInlined(),
				heading: h,
				ren: this
			});
		},

		/**
		 * @override
		 * true if not in OnlyForColors
		 */
		_getValue: function(ctx, h) {
			const pm = ctx.getNodeParent(ctx.getNode());
			return pm.OnlyForColors.length && !_.contains(pm.OnlyForColors, ctx.getNode().PMCBOMColor);
		}
	});
});